module.exports = __webpack_public_path__ + "img/IMG-20191012-WA0041.ee05615f.jpg";